import { TsdMap } from '../../store/TsdMap';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const createTsdMapData = (tsdMapData: TsdMap) => {
  return apiService.callExternalApi<TsdMap>({
    url: `${API_SERVER_URL}/tsd-maps`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: tsdMapData
  });
};

export const deleteTsdMapData = (id: string) => {
  return apiService.callExternalApi<TsdMap>({
    url: `${API_SERVER_URL}/tsd-maps/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listTsdMaps = () => {
  return apiService.callExternalApi<{ tsdMaps: TsdMap[] }>({
    url: `${API_SERVER_URL}/tsd-maps`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
